import application from 'application/application';

import template from './privacy-policies.template.html';

import controller from './privacy-policies.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.privacyPolicies', {
				url: '/politicas-de-privacidade',
				views: {
					'root': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Políticas de Privacidade'
				},
				params: {
					authentication: false
				}
			});

	}]);
